export class CreateTaskInputDto {
    name: string;
    description: string;
    dueDate: Date;
    userId: string;
    companyId: string;
}
